export default {
  'billing.period.day': '{count, plural, one {# day} other {# days}}',
  'billing.period.week': '{count, plural, one {# week} other {# weeks}}',
  'billing.period.month': '{count, plural, one {# month} other {# months}}',
  'billing.period.year': '{count, plural, one {# year} other {# years}}',
  'billing.period.purchase':
    '{duration} per period × {count, plural, one {# period} other {# periods}}',
  'billing.period.oneTime': 'One-time purchase',
  'billing.period.unavailable': 'Period information unavailable',
};
